
import { Component, Prop, Vue } from 'vue-property-decorator';

const DEFAULT_TEST_SOUND = require('../../../assets/sound/notification_sound.mp3');

@Component
export default class SpeakerTest extends Vue {
  @Prop({ type: String, default: '' }) deviceId!: string;
  @Prop({ type: String, default: DEFAULT_TEST_SOUND }) testSoundUrl!: string;

  isPlaying = false;
  private audioEl: HTMLAudioElement | null = null;

  async playTest(): Promise<void> {
    this.audioEl = new Audio(this.testSoundUrl);
    if (this.deviceId && this.deviceId !== 'none') {
      const el = this.audioEl as HTMLAudioElement & { setSinkId?: (id: string) => Promise<void> };
      if (typeof el.setSinkId === 'function') {
        await el.setSinkId(this.deviceId).catch(() => undefined);
      }
    }
    this.audioEl.onended = () => {
      this.isPlaying = false;
      this.audioEl = null;
    };
    this.isPlaying = true;
    await this.audioEl.play().catch(() => {
      this.isPlaying = false;
      this.audioEl = null;
    });
  }

  stopTest(): void {
    if (this.audioEl) {
      this.audioEl.pause();
      this.audioEl.src = '';
      this.audioEl = null;
    }
    this.isPlaying = false;
  }

  beforeDestroy(): void {
    this.stopTest();
  }
}
